import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MembershipCategoryServices from '../services/MembershipCategoryServices';
import useAsync from '../hooks/useAsync';
import HelpTogal from './TogelButton/HelpTogal';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import UpdateMembershipCategory from './Update Model/UpdateMembershipCategory';
import ViewMembershipCategory from './View Model/ViewMembershipCategory';
import SelectCategourySequence from './TogelButton/SelectCategorySequence';
import * as XLSX from 'xlsx';

Modal.setAppElement('#root');

function MembershipCategory() {
  const { data, error, isLoading, run } = useAsync(MembershipCategoryServices.getMembershipCategory);

  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedMembership, setSelectedMembership] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEditDetails = (membership) => {
    setSelectedEdit(membership);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleViewDetails = (membership) => {
    setSelectedMembership(membership);
    setIsModalOpen(true);
  };

  const handleDelete = (membership) => {
    setSelectedEdit(membership);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMembership(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const formatDateTime = (isoString) => {
    if (!isoString) return '-';
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const filteredData = data?.data?.filter(membership =>
    membership?.name?.toLowerCase().includes(searchQuery.toLowerCase().trim())
  );

  if (isLoading) {
    return (
      <div className="right_col" role="main">
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="right_col" role="main">
        <div className="alert alert-danger m-3" role="alert">
          Error loading memberships: {error.message}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
          <div className="my-auto">
            <h5 className="page-title fs-21 mb-1">
              Membership Category List <span className="badge bg-orange">{filteredData?.length || 0}</span>
            </h5>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Membership Category
                </li>
              </ol>
            </nav>
          </div>

          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <Link className="round-add-btn" to="/add-membership-category">
              <img src="img/plus.svg" alt="Add Membership Category" />
            </Link>
          </div>
        </div>

        <div className="container-box px-0 pt-2">
          <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search"
                    value={searchQuery}
                    className='form-control'
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className="search-btn" onClick={() => setSearchQuery(searchQuery)}>Search</button>
                </div>
              </div>
            </div>
          </div>

          <div className="container-box-inner table-reponsive-tabe">
            <table className="table table-striped" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>NAME</th>
                  {/* <th>PRICE</th>
                  <th>DURATION DAYS</th> */}
                  <th>DATE</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {filteredData && filteredData.length > 0 ? (
                  filteredData.map((membership, i) => (
                    <tr key={membership._id || i}>
                      <td>{i + 1}</td>
                      <td>{membership?.name || '-'}</td>
                      {/* <td>{membership?.price || '-'}</td>
                      <td>{membership?.durationDays || '-'}</td> */}
                      <td>{formatDateTime(membership?.createdAt)}</td>
                      <td className="status-toggle">
                        <HelpTogal help={membership} page="MembershipCategory" onSuccess={() => run()} />
                      </td>
                      <td>
                        <div className="action_toggle_outer">
                          <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                            <i className="fa fa-ellipsis-v" />
                          </button>
                          {activeIndex === i && (
                            <div className="action_toggle_content product-edit show d-block">
                              <ul className="list-unstyled">
                                <li>
                                  <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                    <i className="fa fa-close" />
                                  </button>
                                </li>
                                <li>
                                  <button className="approve" style={{ backgroundColor: '#263238' }} onClick={() => handleViewDetails(membership)}>View</button>
                                </li>
                                <li>
                                  <button className="edit" onClick={() => handleEditDetails(membership)}>Edit</button>
                                </li>
                                <li>
                                  <button className="reject" onClick={() => handleDelete(membership)}>Delete</button>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      No memberships found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <UpdateMembershipCategory membership={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>

        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="MembershipCategory" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
        
        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          contentLabel="View Membership"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <ViewMembershipCategory service={selectedMembership} closeModal={closeModal} />
        </Modal>
      </div>
    </>
  );
}

export default MembershipCategory;